// 🔧 store_cart_helpers.js
// ✅ Purpose: Local Store cart helpers
// ✅ Features:
// - Stores cart per event slug
// - Keeps cart isolated between events
// - Supports add, remove, update quantity, clear
// - Uses localStorage only until Stripe checkout phase

export const getStoreCartKey = (eventslug) =>
  `lgv_store_cart_${eventslug}`;

export const getStoreCart = (eventslug) => {
  try {
    const raw = localStorage.getItem(getStoreCartKey(eventslug));
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const saveStoreCart = (eventslug, cartItems) => {
  localStorage.setItem(
    getStoreCartKey(eventslug),
    JSON.stringify(cartItems || [])
  );
};

export const clearStoreCart = (eventslug) => {
  localStorage.removeItem(getStoreCartKey(eventslug));
};

export const addStoreCartItem = (eventslug, item) => {
  const cart = getStoreCart(eventslug);

  const existingIndex = cart.findIndex(
    (cartItem) =>
      cartItem.productId === item.productId &&
      cartItem.variantId === item.variantId
  );

  if (existingIndex >= 0) {
    cart[existingIndex] = {
      ...cart[existingIndex],
      quantity:
        Number(cart[existingIndex].quantity || 0) +
        Number(item.quantity || 1),
    };
  } else {
    cart.push(item);
  }

  saveStoreCart(eventslug, cart);
  return cart;
};